/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type portfolio_PutChildFrameworkStatusItem = {
    evidenceEntryId?: string;
    itemId: string;
    note?: string;
    observedAt: string;
    status: portfolio_PutChildFrameworkStatusItem.status;
};
export namespace portfolio_PutChildFrameworkStatusItem {
    export enum status {
        NOCH_NICHT_BEOBACHTET = 'noch_nicht_beobachtet',
        IN_ENTWICKLUNG = 'in_entwicklung',
        GEFESTIGT = 'gefestigt',
    }
}

